export class XCategorieCours {
  is_categorie: number = 0;
  // INFO
  code: string = "";
  name: string = "";
  // NOTE
  note_total: number | string = 0;
  note_pass:  number | string = 0;
  note_rep:   number | string = 0;
  note_exc:   number | string = 0;
  // STATUS
  is_calc: number = 0;
  is_number: number = 1;
  //
  cat_code: string = '';
  total_cours: number = 0;
  public constructor() {
  }
}
